export default __webpack_public_path__ + "static/media/icon-notif-deconnexion.2fd75812.svg";